import React, { Component } from 'react';
import Detail from '../../components/Customer/BookingDetail.jsx';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

export class BookingDetail extends Component {
    constructor(props) {
        super();
    }
    render() {
        return (
            <div className="arab-right tz-2-com tz-2-main">
                <h4>
                    <FormattedMessage
                        id="bookingDetail"
                        defaultMessage="Booking Detail"
                    />
                </h4>
                <div className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <Detail
                                key={this.props.match.params.bookingId}
                                bookingId={this.props.match.params.bookingId}
                                {...this.props}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const composedComponent = compose();
export default BookingDetail;



// WEBPACK FOOTER //
// ./src/views/User/BookingDetail.jsx